import React from 'react'

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import PropTypes from 'prop-types'

import ProductAnalyticsAbout from './Components/ProductAnalyticsAbout'
import ProductAnalyticsMarketplaceStatistics from './Components/ProductAnalyticsMarketplaceStatistics'
import ProductAnalyticsModelImprovements from './Components/ProductAnalyticsModelImprovements'
import ProductAnalyticsMyProducts from './Components/ProductAnalyticsMyProducts'
import ProductAnalyticsNav from './Components/ProductAnalyticsNav'

class ProductAnalytics extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      analyticsParticipant: this.props.data.user.sellerAnalyticsParticipant,
    }

    this.onTabClick = this.onTabClick.bind(this)
    this.onParticipationAgree = this.onParticipationAgree.bind(this)
  }

  componentDidMount() {
    const staticPlaceholder = document.getElementsByClassName('js-product-analytics-static')[0]

    if (staticPlaceholder && staticPlaceholder.parentNode) {
      staticPlaceholder.parentNode.removeChild(staticPlaceholder)
    }
  }

  onTabClick(tabPaneComponent) {
    dataLayer.push({
      event: 'CustomEvent',
      eventCategory: 'Seller analytics',
      eventAction: 'Select tab',
      eventLabel: tabPaneComponent.name,
    })
  }

  onParticipationAgree() {
    this.setState({ analyticsParticipant: true })
  }

  render() {
    return (
      <Router>
        <div>
          <ProductAnalyticsNav onTabClick={this.onTabClick} />
          <div className="tabs-content">
            <div className="tab-pane is-active">
              <Routes>
                <Route
                  path="/profile/analytics"
                  element={(
                    <ProductAnalyticsMarketplaceStatistics
                      tiersData={{ data: this.props.data, meta: this.props.meta }}
                      tabSwitch={this.onTabClick}
                      analyticsParticipant={this.state.analyticsParticipant}
                      onParticipationAgree={this.onParticipationAgree}
                    />
                  )}
                />
                <Route path="/profile/analytics/models" element={<ProductAnalyticsMyProducts />} />
                <Route path="/profile/analytics/improvements" element={<ProductAnalyticsModelImprovements />} />
                <Route
                  path="/profile/analytics/about"
                  element={<ProductAnalyticsAbout analyticsParticipant={this.state.analyticsParticipant} />}
                />
              </Routes>
            </div>
          </div>
        </div>
      </Router>
    )
  }
}

ProductAnalytics.propTypes = {
  data: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
}

export default ProductAnalytics
